import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import AuthRedirect from '../AuthRedirect'
import LoginScreen from '../LoginScreen'
import Admin from '../Admin'
import AuthProvider from '../AuthProvider'
import Nav from '../Nav'
import { Container } from 'semantic-ui-react'
import { ROOT as ADMIN_ROOT } from '../Admin/routes'
import { LOGIN } from './routes'
import 'semantic-ui-css/semantic.min.css'
import './App.css'

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Container>
          <Nav />
          <Route path="/" component={AuthRedirect} />
          <Route exact path={LOGIN} component={LoginScreen} />
          <Route path={ADMIN_ROOT} component={Admin} />
        </Container>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.jsx